import Feature13 from './Feature13'
export default Feature13
